import { alpha, darken, lighten } from '@mui/material/styles';

const getChartColors = (theme, count = 10) => {
  const primary = theme.palette.primary.main;

  const palette = [
    darken(primary, 0.24),
    darken(primary, 0.12),
    primary,
    lighten(primary, 0.08),
    lighten(primary, 0.18),
    alpha(primary, 0.88),
    alpha(primary, 0.76),
    alpha(primary, 0.62),
    alpha(primary, 0.48),
    alpha(primary, 0.32),
  ];

  return Array.from({ length: count }, (_, index) => palette[index % palette.length]);
};

export default getChartColors;
